import { t as toggleBooleanAttribute } from './toggleBooleanAttribute-Cp5m6OeZ.js';

class CollapsibleElement extends HTMLElement {
  /** @type {HTMLElement} */ #controller = this.querySelector('[aria-controls]');
  /** @type {HTMLElement} */ #target = this.#controller.ariaControlsElements[0];
  /** @type {boolean} */ #persist = this.hasAttribute('persist');

  connectedCallback() {
    if (this.#persist) this.#restoreState();
    this.#controller.addEventListener('click', () => this.#handleClick());
  }

  #handleClick() {
    toggleBooleanAttribute(this.#controller, 'aria-expanded');
    toggleBooleanAttribute(this.#target, 'aria-hidden');
    if (this.#persist) this.#saveState();
  }

  #storageKey() {
    return `collapsible:${this.#target.id}`;
  }

  #saveState() {
    const expanded = this.#controller.getAttribute('aria-expanded') === 'true';
    sessionStorage.setItem(this.#storageKey(), expanded);
  }

  #restoreState() {
    const stored = sessionStorage.getItem(this.#storageKey());
    if (stored === null) return;

    const expanded = stored === 'true';
    this.#controller.setAttribute('aria-expanded', String(expanded));
    this.#target.setAttribute('aria-hidden', String(!expanded));
  }
}

customElements.define('collapsible-element', CollapsibleElement);
